<template>
    <div class="full">
        <login v-if="islogin" :subject_code = "subject_code"></login>
        <index v-if="isindex"></index>
    </div>
</template>
<script>

import Login from "./login"
import Index from "./index"
export default {
    name: '',
    components: {Login,Index},
    data() {
        return {
            project_code:"",
            islogin:false,
            isindex:false,
            subject_code:""
        }
    },
    created(){
        
        this.$store.commit("user",{});
        this.$store.commit("project",{});
        this.$store.commit("exam",{});
		this.$store.commit("answer",{});
        this.$store.commit("config",{});
        
        this.getConf();
    },
    methods: {
        getConf(){
            let project_code = this.$route.params.project_code;
            this.project_code = project_code;


            
			this.$req.post("sign/getConf",{project_code:project_code}).then(res=>{
				if(res.flag == 1){
                    let project={
                        project_code,
                        project_name:res.data.project_name,
                        project_id:res.data.config.project_id
                    }
                    
                    this.$store.commit("project",project);
                    this.$store.commit("config", res.data.config);
                    this.getSubject();
				}
			});
        },
        getSubject(){
            this.$req.post("sign/selectSubject",{}).then(res=>{
                if(res.flag == 1){
                    this.subject = res.data;
                    let exam={
                        subject:res.data
                    }
                    this.$store.commit("exam",exam);

                    if(this.$store.state.config.is_home_page == 1){
                        //this.$router.push({name:"Index",params:{project_code:this.project_code}});
                        this.isindex = true;
                    }else{
                        exam.subject[0].use_status = 'ing';
                        this.$store.commit("exam",exam);
                        //this.$router.push({name:"Login",params:{subject_code:subjectData.subject_code,project_code:this.project_code}});
                        this.islogin = true;
                        this.subject_code = res.data[0].subject_code;
                        console.log(this.subject_code)
                    }
                }
            });
        }
    },
}
</script>
<style lang='scss' scoped>
</style>